import React from 'react';
import { Box } from '@styleseat/ui';
import { colors } from '@styleseat/brand';
import { Touchable } from '../../../ui';
import { CloseIcon } from '../../../ui/Icons/CloseIcon';

export type IncentivesCloseIconProps = {
  onDismiss: () => void;
  size: number;
  testID?: string;
  iconColor?: string;
};

const IncentivesCloseIcon: React.FC<IncentivesCloseIconProps> = ({
  onDismiss,
  size,
  testID,
  iconColor,
}) => (
  <Touchable
    onClick={onDismiss}
    testID={testID || 'incentives-close-icon'}
  >
    <Box
      padding={8}
      color={colors.transparent}
      borderRadius={100}
    >
      <CloseIcon
        width={size}
        height={size}
        viewBox="0 0 20 20"
        color={iconColor}
      />
    </Box>
  </Touchable>
);

export default IncentivesCloseIcon;
